import { render, staticRenderFns } from "./SetEmailRecoverPasswordCard.vue?vue&type=template&id=d22ef2ba&scoped=true"
import script from "./SetEmailRecoverPasswordCard.vue?vue&type=script&lang=js"
export * from "./SetEmailRecoverPasswordCard.vue?vue&type=script&lang=js"
import style0 from "./SetEmailRecoverPasswordCard.vue?vue&type=style&index=0&id=d22ef2ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22ef2ba",
  null
  
)

export default component.exports